import React from "react";

export const LoadingSpinner = ({
  title,
  spinnerClassAppend,
  spinnerClassOverride,
  spinnerStyleOverride,
  containerStyleAppend,
}) => {
  return (
    <div style={{ textAlign: "center", ...containerStyleAppend }}>
      <div
        className={
          spinnerClassOverride
            ? "spinner-border " + spinnerClassOverride
            : "spinner-border p-3 m-2" +
              (spinnerClassAppend ? " " + spinnerClassAppend : "")
        }
        style={spinnerStyleOverride}
        role="status"
      >
        <span className="sr-only">Loading...</span>
      </div>
      {title && (
        <>
          <br />
          {title}
        </>
      )}
    </div>
  );
};
